// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 4999 ? "f31aec94" : chunkId) + "." + {"4999":"ce2f7dbe49ed83fd","9411":"3e561a684e95351b"}[chunkId] + ".js";
};